import React from 'react';
import { Ethnicity as EthnicityType } from '../utils/data_types';
import { THEME_COLORS } from '../utils/theme';
import { SectionHeader } from './styles';
import styled from 'styled-components/macro';
import PieChartEthnicity from './graphs/PieChart';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Graph = styled.div`
  width: 75vw;
  min-width: 0;
  min-height: 0;
  margin: 15px;
  padding: 15px;
`;

// f
interface Props {
  ethnicityData: Array<EthnicityType>;
}

export const Ethnicity: React.FC<Props> = props => {
  let data = props.ethnicityData;
  return (
    <SectionHeader color={THEME_COLORS.lightGrey}>
      Ethnicity
      <Container>
        <Graph>
          <PieChartEthnicity
            sliceNames={data.map(eth => eth.ethnicityType)}
            data={data.map(eth => eth.totalEthnicity)}
            show_legend={true}
            show_percentages={false}
            hover_num={180}
            show_leg_percentage={true}
            show_legend_first={true}
          />
        </Graph>
      </Container>
    </SectionHeader>
  );
};
